module.exports = __webpack_public_path__ + "13b4799b721c49a6d393d672ce97f33d.fbx";